// src/components/chatIDModule.js

let chatID = null; // Initialisation avec une valeur par défaut ou null

export const getChatID = () => chatID;

export const setChatID = (newChatID) => {
  chatID = newChatID;
};
